// import external libraries
import dayjs from 'dayjs';
import { create } from 'zustand';

// import types
import type { DateNavigationHoursStore } from './DateNavigationHours.types';

export const useDateNavigationHoursStore = create<DateNavigationHoursStore>(
  (set) => ({
    selectedDate: dayjs().toDate(),
    selectedDateRange: [dayjs().toDate(), dayjs().toDate()],
    openPreviousMonthsRange: null,
    setSelectedDate: (newDate) =>
      set(() => ({
        selectedDate: newDate
      })),
    setSelectedDateRange: (newDate) =>
      set(() => ({
        selectedDateRange: newDate
      })),
    setOpenPreviousMonthsRange: (range) =>
      set(() => ({
        openPreviousMonthsRange: range
      }))
  })
);
